import Entity from './entity'

export default class Resource extends Entity<string>{
    content: string;
    title: string;
    contentForm: number;
    topicTwoId: number;
    topicOneId: number;
    gradeType: number;
    sortNo: number; 
    externalType: number = 2;
    attachmentDownloads: number;
    clickVolume: number;
    isSystemManager: number;
    attachment: string;
    creationTime: string;
    author: string;
    issued: string;
    description: string;
    isRecommend: boolean;
    categoryId: number;
    isAudit: boolean;
    chapterId: number;
    resourceCategoryId: number;
    readingPoints: number;
    pdfFiles: any;
    pdfFilePath: string;
    attachmentFiles: any;
    attachmentPaths: any;
    attachmentPath: string;
}